'use strict';

/**
 * iPad - Custom Modernizr Test
 *
 * If the device is an iPad class ipad will be added to <html>.
 *
 * @author Matthias Giger <matthias.giger@namics.com>
 */
Modernizr.addTest('ipad', function () {
  return (/(iPad)/g.test(navigator.userAgent)
  );
});